import * as React from 'react'

import { BackgroundToLightnessProvider } from '@factorialco/deprecated-design-system'
import cn from 'classnames/bind'

import styles from './index.module.css'

const cx = cn.bind(styles)
type DIRECTIONS = 'top' | 'bottom' | 'left' | 'right'
type TYPES = 'correct' | 'wrong' | 'brand' | 'accent' | 'light' | 'dark' | 'default'
interface Props {
  arrow?: DIRECTIONS
  type?: TYPES | null | undefined
  compact?: boolean
  darken?: boolean
}

const typeToBackgroundColor = (type: TYPES | null | undefined) => {
  const colorMap = {
    correct: 'lime1000',
    brand: 'viridian1200',
    wrong: 'radicalRed1000',
    accent: 'champagne800',
    light: 'grey000White',
    dark: 'grey800',
    default: 'grey200',
  } as const

  return colorMap[type || 'default']
}

// TODO: Should we move this to the design-system?
const InlineTooltip = ({
  arrow,
  children,
  type,
  compact,
  darken,
}: React.PropsWithChildren<Props>) => (
  <BackgroundToLightnessProvider background={typeToBackgroundColor(type)}>
    <div
      className={cx(styles.root, arrow, type, {
        compact,
        darken,
      })}
    >
      {children}
    </div>
  </BackgroundToLightnessProvider>
)

export default InlineTooltip
